<template>
  <svg viewBox="0 0 36 36" class="circular-chart orange">
    <path
      class="circle-bg"
      d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      class="circle"
      :stroke-dasharray="`${progressValue}, 100`"
      d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
    />
  </svg>
</template>

<script lang="ts">
import { computed, Ref } from 'vue';

export default {
  name: 'CircularProgress',
  props: {
    progress: Number,
  },
  setup(props: { progress: number }): { progressValue: Ref<number> } {
    const progressValue: Ref<number> = computed(() => props.progress);
    return {
      progressValue,
    };
  },
};
</script>

<style lang="scss">
.circular-chart {
  display: block;
  max-width: 80%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.25);
  stroke-width: 2;
}

.circle {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
  transition: all 0.25s ease-in-out;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.orange .circle {
  stroke: $crimson;
}
</style>
